module.exports = function() {
  return new Worker("/" + "svelte-transpiler.ca28c1e0.worker.js");
};